// extracted by mini-css-extract-plugin
module.exports = {"guarantyText":"style_guarantyText__HcDOn","guarantyGiftGuideText":"style_guarantyGiftGuideText__6PMFy"};